export default __webpack_public_path__ + "static/media/100_47751.27124fff.jpg";